import type { TMetricType } from '../types';

export const METRICS: TMetricType[] = ['download', 'mau', 'revenue'];

const DAILY_METRICS: TMetricType[] = ['download', 'dau', 'revenue'];

const WEEKLY_METRICS: TMetricType[] = ['download', 'wau', 'revenue'];

const MONTHLY_METRICS: TMetricType[] = ['download', 'mau', 'revenue'];

const QUARTERLY_METRICS: TMetricType[] = [];

const YEARLY_METRICS: TMetricType[] = [];

export const METRICS_MAP: Record<IGranularity, TMetricType[]> = {
  daily: DAILY_METRICS,
  weekly: WEEKLY_METRICS,
  monthly: MONTHLY_METRICS,
  quarterly: QUARTERLY_METRICS,
  yearly: YEARLY_METRICS,
};

export const DATASOURCE_METRICS = ['sensortower__download', 'sensortower__mau', 'sensortower__revenue'];

// 品类数据源类型列表（统一配置，分发给 Segment 和品类筛选器）
export const CASUAL_GENRE_PROFILE_GENRE_SOURCES = ['sensortower', 'appmagic'];

const DATASOURCE_METRIC_MAP: Record<TMetricType, string> = {
  dau: 'sensortower__dau',
  wau: 'sensortower__wau',
  mau: 'sensortower__mau',
  download: 'sensortower__download',
  revenue: 'sensortower__revenue',
};

const GAME_METRIC_MAP: IRecord<string> = {
  dau: 'avg_dau',
  wau: 'avg_wau',
  mau: 'avg_mau',
};

export const getGameMetric = (metric: string): string => {
  return GAME_METRIC_MAP[metric] || metric;
};

const GAME_DATASOURCE_METRIC_MAP: IRecord<string> = {
  sensortower__dau: 'sensortower__avg_dau',
  sensortower__wau: 'sensortower__avg_wau',
  sensortower__mau: 'sensortower__avg_mau',
};

export const getGameDataSourceMetric = (metric: string): string => {
  return GAME_DATASOURCE_METRIC_MAP[metric] || metric;
};

/**
 * 根据粒度获取指标
 */
export const getDatasourceMetrics = (granularity: IGranularity): string[] => {
  const metrics = METRICS_MAP[granularity] || [];
  return metrics.map((metric) => {
    return DATASOURCE_METRIC_MAP[metric];
  });
};

export const GENRE_DIMENSION_MAP = {
  MAIN_GENRE: 'mainGenre',
  SUB_GENRE: 'subGenre',
  SUPER_GENRE: 'superGenre',
  MAJOR_CATEGORY: 'majorCategory',
  MID_CATEGORY: 'midCategory',
  SUB_CATEGORY: 'subCategory',
} as const;

/**
 * 指标名称映射
 */
export const METRIC_NAME_I18N_KEY_MAP: Record<TMetricType, string> = {
  dau: 'dbi_metric_dau',
  wau: 'dbi_metric_wau',
  mau: 'dbi_metric_mau',
  revenue: 'dbi_metric_revenue',
  download: 'dbi_metric_downloads',
};

/**
 * 饼状图中心标题其他配置
 */
export const PIE_CHART_CENTER_TITLE_CONFIGS: { top: number | string; left: number | string } = {
  top: '49%',
  left: '49%',
};

/**
 * 品类数据源与 Product Model 的映射配置
 * 用于切换品类数据源时自动勾选对应的 Product Model 选项
 */
export const GENRE_SOURCE_TO_PRODUCT_MODEL_MAP: IRecord<string[]> = {
  sensortower: ['Casual', 'Hybridcasual', 'Hypercasual'],
};
